<template>
  <div id="app">
    <router-view name="header"></router-view>
    <main>
      <fade-transition origin="center" mode="out-in" :duration="250">
        <router-view />
      </fade-transition>
    </main>
    <router-view name="footer"></router-view>
  </div>
</template>
<script>
import { FadeTransition } from "vue2-transitions";
import { Auth } from "aws-amplify";

const $ = require("jquery");
window.$ = $;

export default {
  components: {
    FadeTransition
  },
  created() {
    if (!this.$store.state.signedIn) {
      this.findUser();
    }
  },
  methods: {
    async findUser() {
      var protected_url = [
        '/historial-redenciones',
        '/actualizar-perfil',
      ]
      const currentPath = this.$router.history.current.path;
      try {
        const user = await Auth.currentAuthenticatedUser();
        this.$store.commit("setSignIn", user);
        if (currentPath == "/login" || currentPath == "/registro") {
          this.$router.push("/perfil");
        }
      } catch (err) {
        this.$store.commit("setSignOut");
        if(protected_url.indexOf(currentPath) > 0){
          this.$router.push("/login");
        }
      }
    }
  }
};
</script>
